import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=99d5bc2a&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=ts"
export * from "./Pay.vue?vue&type=script&lang=ts"
import style0 from "./Pay.vue?vue&type=style&index=0&id=99d5bc2a&prod&lang=scss"
import style1 from "./Pay.vue?vue&type=style&index=1&id=99d5bc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d5bc2a",
  null
  
)

export default component.exports